module.exports = __webpack_public_path__ + "img/jon_smith_2.acd5a10f.png";